import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { HeaderComponent } from './common/components/header/header.component';
import { SideMenuBarComponent } from './common/components/side-menu-bar/side-menu-bar.component';
import { FactoryInformationComponent } from './factory-information/factory-information.component';
import { IncidentUploadComponent } from './incident-upload/incident-upload.component';
import { IncidentUploadSQLComponent } from './incident-upload-SQL/incident-upload-SQL.component';
import { QaMatrixCreationComponent } from './qa-matrix-creation/qa-matrix-creation.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { StandardInstructionComponent } from './standard-instruction/standard-instruction.component';
import { DummyComponent } from './common/components/dummy/dummy.component';
import { DpiParetoChartComponent } from './dashboard/dpi-pareto-chart/dpi-pareto-chart.component';
import { PieChartComponent } from './dashboard/pie-chart/pie-chart/pie-chart.component';
import { ErrorPageComponent } from './common/components/error-page/error-page.component';
import { LossTreeComponent } from './loss-tree/loss-tree.component';
import { DashboardSqlComponent } from './dashboard-sql/dashboard-sql.component';
import { CurrencyExchangeRateComponent } from './currency-exchangerate/currency-exchangerate.component';
import { ProjectStatusReportComponent } from './project-status-report/project-status-report.component';
import { DeleteIncidentDataComponent } from './delete-incident-data/delete-incident-data.component';
import { DeleteHistoryComponent } from './delete-history/delete-history.component';
import { QualityMatrixAnalyticsComponent } from './quality-matrix-analytics/quality-matrix-analytics.component';
import { ProcessParetoReportComponent } from './dashboard-sql/process-pareto-report/process-pareto-report.component';
import { ParetoReportComponent } from './dashboard-sql/pareto-report/pareto-report.component';
import { QualityMatrixDataComponent } from './quality-matrix-data/quality-matrix-data.component';
import { DefectsCountBlockComponent } from './dashboard-sql/defects-count-block/defects-count-block.component';
import { DpiReductionAnalysisComponent } from './dpi-reduction-analysis/dpi-reduction-analysis.component';
import { IncidentUploadStatusComponent } from './incident-upload-status/incident-upload-status.component';
import { ComparativeAnalyticsComponent } from './comparative-analytics/comparative-analytics.component';
import { MaintenancePageComponent } from './common/components/maintenance/maintenance-page.component';
import { AuthGuardMaintenance } from './common/services/auth-guard.service';
import { MsalGuard } from '@azure/msal-angular';

// created routes for lazy loading implementation
const routes: Routes = [
  { path: '', component: LandingPageComponent, canActivate: [MsalGuard]},
  { path: 'maintenance', component: MaintenancePageComponent, canActivate: [MsalGuard]},
  { path: 'error', component: ErrorPageComponent, canActivate: [MsalGuard]},
  { path: 'factoryconfig', component: FactoryInformationComponent, canActivate: [MsalGuard]},
  { path: 'files', component: IncidentUploadComponent, canActivate: [MsalGuard]},
  { path: 'filesSQL', component: IncidentUploadSQLComponent, canActivate: [MsalGuard]},
  { path: 'qamatrix/:fileId', component: QaMatrixCreationComponent, canActivate: [MsalGuard]},
  { path: 'instruction', component: StandardInstructionComponent, canActivate: [MsalGuard]},
  { path: 'dashboard/:fileId', component  : DashboardComponent, canActivate: [MsalGuard]},
  { path: 'dashboardsql', component  : DashboardSqlComponent, canActivate: [MsalGuard]},
  { path: 'currencyexchange', component  : CurrencyExchangeRateComponent, canActivate: [MsalGuard]},
  { path: 'projectstatusreport', component  : ProjectStatusReportComponent, canActivate: [MsalGuard]},
  { path: 'configrator', component: DummyComponent, canActivate: [MsalGuard]},
  { path: 'losstree', component: LossTreeComponent, canActivate: [MsalGuard]},
  { path: 'deleteincidentdata', component: DeleteIncidentDataComponent, canActivate: [MsalGuard]},
  { path: 'deletehistory', component: DeleteHistoryComponent, canActivate: [MsalGuard]},
  /*{ path: 'qualitymatrixanalytics', component: QualityMatrixAnalyticsComponent, canActivate: [AuthenticationGuard]},*/
  { path: 'processparetoreport', component: ProcessParetoReportComponent, canActivate: [MsalGuard]},
  { path: 'paretoreport', component: ParetoReportComponent, canActivate: [MsalGuard]},
  { path: 'qualitymatrixdata', component: QualityMatrixDataComponent, canActivate: [MsalGuard]},
  { path: 'defectscountblock', component: DefectsCountBlockComponent, canActivate: [MsalGuard]},
  { path: 'dpireductionanalysis', component: DpiReductionAnalysisComponent},
  { path: 'datauploadstatus', component: IncidentUploadStatusComponent},
  { path: 'qualitymatrixanalytics', component: ComparativeAnalyticsComponent, canActivate: [MsalGuard]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
